import styled, { css } from 'styled-components'

const baseStyles = ({ theme }) => css`
  width: 100%;
  padding-right: 1rem;

  @media (min-width: ${theme.media.tablet}) {
    padding-right: 0;
  }
`

export const Wrapper = styled('div')(baseStyles)
